import React, { useState, useEffect, Fragment, useRef } from 'react';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../Common";
import { Chip, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { employeeHarvestingJobEditSchema } from "../employeeHarvestingJobEditSchema";
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import '../../Common/Table/table.css';
import _, { flatMap, xorBy } from 'lodash';
import MessageModal from '../../../UI/Modal/MessageModal';
import { Checkbox } from "@material-ui/core";
import MaterialTable from "material-table";
import { Grid } from '@material-ui/core';
import moment from 'moment'

const screenCode = 'EMPLOYEEHARVESTINGJOBEDIT'

export function EmployeeHarvestingJobEdit(props) {

    const componentRef = useRef();
    const [cardActivateFiltering, setCardActivateFiltering] = useState([]);
    const [saveData, setSaveData] = useState([]);
    let y = 0;
    const [isAllSelect, setIsAllSelect] = useState(true);
    useEffect(() => {
        let x = cardActivateFiltering.length;
        let count = saveData.filter((obj) => obj.isSelected === true).length;
        if (x === count) {
            setIsAllSelect(false);
        }
        else {
            setIsAllSelect(true);
        }
    }, [saveData])

    const [reportData, setReportData] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const selectAll = () => {
        setCheckAll(!checkAll);
    };

    const [isViewSelect, setIsViewSelect] = useState(true);
    const [allHaverstingJobType, setHaverstingJobType] = useState([]);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    console.log(allHaverstingJobType);
    const [groups, setGroups] = useState([]);
    const [isViewButton, setIsViewButton] = useState(true);
    const [devisions, setDevisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [isHide, setIsHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        employeeTypeID: "0",
        employeeCode: "",
        jobTypeID: "0",
        toDate: "",
        fromDate: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(employeeHarvestingJobEditSchema).options({ allowUnknown: true });
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions(),
            getEmployeeTypesForDropdown()
        )
    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            getallAvailableHaverstingJobTypeForDropdown(),
            setIsTableHide(true),
        )
    }, [searchData.employeeTypeID])

    useEffect(() => {
        trackPromise(setCardActivateData());
    }, [reportData]);

    useEffect(() => {
        trackPromise(handleSelectedJob(), isSelected());
    }, [searchData.jobTypeID]);

    async function setCardActivateData() {
        await setCardActivateFiltering(reportData);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEEHARVESTINGJOBEDIT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getAllGroups() {
        const result = await service.getGroups()
        setGroups(result);
    }

    async function getEstates() {
        var data = await service.getEstatesByGroupID(searchData.groupID);
        setEstates(data)
    }

    async function getDevisions() {
        const result = await service.getDivisions(searchData.operationEntityID)
        setDevisions(result)
    }

    async function getEmployeeTypesForDropdown() {
        const result = await service.GetEmployeeTypesData();
        setEmployeeTypes(result);
    }

    async function getallAvailableHaverstingJobTypeForDropdown() {
        let filteredData = await service.getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID(searchData.collectionPointID, searchData.employeeTypeID);
        setHaverstingJobType(filteredData);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, employeeHarvestingJobEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }

    async function handleSearch() {
        setIsTableHide(true);
        await timeout(1000);
        const reportData = await service.GetHarvestingJobEmployee(searchData.operationEntityID, searchData.collectionPointID, searchData.employeeTypeID, searchData.employeeCode, searchData.fromDate, searchData.toDate);

        setReportData(reportData);
        if (reportData.length === 0) {
            setIsTableHide(true);
        } else {
            setIsTableHide(false);
        }
    }

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }

    async function handleSelectedJob() {
        if (searchData.jobTypeID === "0") {
            setIsViewSelect(true)
        }
        else {
            setIsViewSelect(false)
        }
    }

    async function handleApprove(e) {
        e.preventDefault()

        reportData.forEach(x => {
            x.haverstingJobTypeID = parseInt(searchData.jobTypeID);
            x.userID = parseInt(tokenService.getUserIDFromToken());
        })

        let FinalData = {
            saveData: saveData,
            updateData: reportData
        }

        const response = await service.UpdateEmployeeHaverstingJobType(FinalData)
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
        refreshPage();
    }

    function refreshPage() {
        window.location.reload(false);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                clearState();
                setIsTableHide(true);
                setIsViewSelect(true);
                setMessageModel({ ...messageModel, hidden: true })

            }, 1500);
        }
    }

    function clearState() {
        setsearchData({
            ...searchData,
            collectionPointID: '0',
            employeeTypeID: '0',
            employeeCode: '',
            jobTypeID: '0'
        })
    }

    function handleClick(data, e) {

        let cardData = {
            cardNumber: data.cardNumber,
            userID: parseInt(tokenService.getUserIDFromToken()),
            employee: data.employeeID,
            haverstingJobTypeID: parseInt(searchData.jobTypeID),
            isSelected: data.isSelected
        };

        let dataRecords = [...saveData];
        let dataReport = [...reportData];

        var isEnable = dataRecords.find((p) => p.cardNumber == data.cardNumber);
        if (isEnable === undefined) {
            dataRecords.push(cardData);
        } else {
            var index = dataRecords.indexOf(isEnable);
            dataRecords.splice(index, 1);
        }
        dataReport.forEach(x => {
            if (x.cardNumber == data.cardNumber) {
                x.isSelected = !x.isSelected
            }

        });
        setSaveData(dataRecords);

        if (dataRecords.length === 0) {
            setIsViewButton(true);
        } else {
            setIsViewButton(false);
        }

    }

    function isSelected() {
        var array = [];
        array = reportData;
        array.forEach(x => {
            var isEnable = x.jobTypeList.find((p) => p.jobTypeID == parseInt(searchData.jobTypeID));

            if (isEnable !== undefined) {
                x.isSelected = true;

            }
            else {
                x.isSelected = false;
            }
        });
        setReportData(array);
    }

    function handleClickAll(e) {
        var cardDataCopy = [...saveData];
        if (e.target.checked) {
            cardActivateFiltering.forEach(x => {
                x.isSelected = true;
                let cardData = {
                    cardNumber: x.cardNumber,
                    userID: parseInt(tokenService.getUserIDFromToken()),
                    employee: x.employeeID,
                    haverstingJobTypeID: parseInt(searchData.jobTypeID),
                    isSelected: x.isSelected
                };
                var isEnable = cardDataCopy.find((p) => p.employeeID == x.employeeID);
                if (isEnable === undefined) {
                    cardDataCopy.push(cardData);
                }

            });
            setSaveData(cardDataCopy);
            setIsViewButton(false);

        } else {
            cardActivateFiltering.forEach(x => {
                x.isSelected = false;
            });
            var emptyArray = [];
            setSaveData(emptyArray);
            setIsViewButton(true);
        }
    }

    function isChecked(data) {

        return (!(data.isSelected === false))
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Employee Harvesting Job Edit"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Division *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(devisions)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["fromDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["toDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="employeeTypeID">Employee Type *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="employeeTypeID"
                                        name="employeeTypeID"
                                        value={searchData.employeeTypeID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select employee type--</MenuItem>
                                        {generateDropDownMenu(employeeTypes)}
                                    </Select>
                                    {errors["employeeTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeTypeID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <TextField fullWidth label="Employee Code"
                                        name="employeeCode"
                                        id="employeeCode"
                                        value={searchData.employeeCode}
                                        type="text"
                                        maxLength="100"
                                        onChange={(e) => handleChange(e)} />
                                    {errors["employeeCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeCode"]}</FormHelperText>}
                                </div>
                                <div hidden={isTableHide} className="col-md pb-1">
                                    <InputLabel shrink id="jobTypeID">Job Type *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="jobTypeID"
                                        name="jobTypeID"
                                        value={searchData.jobTypeID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Job type--</MenuItem>
                                        {generateDropDownMenu(allHaverstingJobType)}
                                    </Select>
                                    {errors["jobTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["jobTypeID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Serach"
                                        onClick={() => trackPromise(handleSearch())}
                                    />
                                </div>
                            </div>
                            <Grid hidden={isTableHide} item md={12} xs={12}>
                                <MaterialTable
                                    columns={[
                                        {
                                            title: 'Division Name', field: 'collectionPointName',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Card No', field: 'cardNumber',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Emp Name', field: 'firstName',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Emp Code', field: 'employeeCode',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never'
                                        },
                                        {
                                            title: 'Reg No', field: 'epfNo',
                                            headerStyle: { fontWeight: "bold" },
                                        },
                                        {
                                            title: 'Created Date', field: 'createdDate',
                                            headerStyle: { fontWeight: "bold" },
                                            render: (data) => (
                                                moment(data).format('lll')
                                            )
                                        },
                                        {
                                            title: 'Modified Date', field: 'modifiedDate',
                                            headerStyle: { fontWeight: "bold" },
                                            render: (data) => (
                                                moment(data).format('lll')
                                            )
                                        },

                                        {
                                            title: 'Existing Jobs',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never',
                                            sorting: false,
                                            render: (data) => (
                                                data.jobTypeList.map((i) => (
                                                    <Chip size="small" label={i.haverstingJobTypeName + " "} style={{ color: 'green' }} />
                                                ))
                                            ),
                                        },
                                        {
                                            title: 'Selected Job',
                                            headerStyle: { fontWeight: "bold" },
                                            editable: 'never',
                                            sorting: false,
                                            render: (data) => (
                                                <Chip size="small" label={allHaverstingJobType[searchData.jobTypeID]} style={{ color: 'green' }} />
                                            ),
                                        },
                                        {
                                            title: (
                                                <label>
                                                    <Checkbox
                                                        disabled={isViewSelect}
                                                        color="primary"
                                                        onClick={(e) => handleClickAll(e)}
                                                        onChange={selectAll}
                                                    ></Checkbox>
                                                    Select All
                                                </label>
                                            ),
                                            headerStyle: { fontWeight: "bold" },
                                            sorting: false,
                                            field: "select",
                                            type: "boolean",
                                            render: (data) => (
                                                <Checkbox
                                                    disabled={isViewSelect}
                                                    color="primary"
                                                    onClick={(e) => handleClick(data, e)}
                                                    checked={isChecked(data)}
                                                ></Checkbox>
                                            ),
                                        },
                                    ]}
                                    data={reportData}
                                    options={{
                                        exportAllData: true,
                                        showTitle: false,
                                        headerStyle: { textAlign: "left", height: '1%' },
                                        cellStyle: { textAlign: "left" },
                                        columnResizable: false,
                                        pageSize: 10
                                    }}
                                />
                            </Grid>
                            <div hidden={isTableHide} className="card-footer">
                                <input
                                    type="submit"
                                    value="update"
                                    className="btn btn-primary"
                                    onClick={handleApprove}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}



